export default {
  "title": "Foxit PDF Editor",
  "content": "Dear users, your school has purchased the Foxit PDF Editor desktop edition license. You can download, install and use the desktop or mobile version on the education page of Foxit official website.",
  "dismissLabel": "Don't remind me again",
  "confirm": "Thanks, I got it",
  "goNow": "Visit Now"
}